import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Formly field type for single checkbox
 */
@Component({
  selector: 'app-checkbox-field',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule],
  template: `
    <div class="checkbox-field">
      <label class="checkbox-label">
        <input
          type="checkbox"
          [formControl]="formControl"
          [formlyAttributes]="field"
          class="checkbox-input"
          [attr.data-testid]="props['attributes']?.['data-testid']"
        />
        <span class="label-text">{{ props['label'] }}</span>
      </label>
      @if (props['description']) {
        <p class="field-description">{{ props['description'] }}</p>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .checkbox-field {
        display: flex;
        flex-direction: column;
        gap: var(--gap-xs);
        margin-bottom: var(--margin-md);
      }

      .checkbox-label {
        display: flex;
        align-items: center;
        gap: var(--gap-sm);
        cursor: pointer;
      }

      .checkbox-input {
        width: 18px;
        height: 18px;
        cursor: pointer;
      }

      .label-text {
        font-size: var(--font-size-md);
        color: var(--fg-primary);
      }

      .field-description {
        font-size: var(--font-size-sm);
        color: var(--fg-secondary);
        margin: 0 0 0 26px;
      }
    `,
  ],
})
export class CheckboxFieldComponent extends FieldType<FieldTypeConfig> {}
